export default __webpack_public_path__ + "static/media/alert-black.eea7a318.svg";